import { useEffect, useMemo, useRef, useState } from "react";
import "../airportAutocomplete/AirportAutocomplete.css";

const CarLocationAutocomplete = ({ value, onChange, placeholder = "Enter city or location", label, locations = [], loading = false }) => {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [openUp, setOpenUp] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    setQuery("");
  }, [value]);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  useEffect(() => {
    if (!open || !wrapperRef.current) return;
    const PANEL_HEIGHT = 320;
    const rect = wrapperRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;
    setOpenUp(spaceBelow < PANEL_HEIGHT && spaceAbove > spaceBelow);
  }, [open]);

  const results = useMemo(() => {
    const text = query.trim().toLowerCase();
    if (text.length < 1) return locations.slice(0, 20);
    return locations
      .filter((loc) =>
        [loc.location_name, loc.city, loc.address, loc.country_code]
          .filter(Boolean)
          .some((field) => field.toLowerCase().includes(text))
      )
      .slice(0, 20);
  }, [locations, query]);

  const handleSelect = (location) => {
    onChange(location);
    setQuery("");
    setOpen(false);
  };

  const displayValue = open ? query : (value ? value.location_name : query);

  return (
    <div className="airportAutocomplete" ref={wrapperRef}>
      {label && <label>{label}</label>}
      <input
        type="text"
        placeholder={placeholder}
        value={displayValue}
        onChange={(e) => {
          setQuery(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        autoComplete="off"
      />

      {!open && value && (
        <div className="airportAutocomplete__subtitle">
          {value.city}{value.country_code ? `, ${value.country_code}` : ''}
        </div>
      )}

      {open && query.trim().length >= 1 && (
        <div className={`airportAutocomplete__panel ${openUp ? "airportAutocomplete__panel--up" : ""}`}>
          {loading && <div className="airportAutocomplete__empty">Loading locations...</div>}
          {!loading && results.length === 0 && (
            <div className="airportAutocomplete__empty">No locations found</div>
          )}
          {!loading &&
            results.map((location) => (
              <button
                type="button"
                key={location.id}
                className="airportAutocomplete__item"
                onClick={() => handleSelect(location)}
              >
                <span className="airportAutocomplete__details">
                  <span className="airportAutocomplete__city">{location.location_name}</span>
                  <span className="airportAutocomplete__name">{location.address || `${location.city}, ${location.country_code}`}</span>
                </span>
              </button>
            ))}
        </div>
      )}
    </div>
  );
};

export default CarLocationAutocomplete;
